module.exports = require("change-case");


//////////////////
// WEBPACK FOOTER
// external "change-case"
// module id = 29
// module chunks = 0